export function applyPasswordToConfigUrl(configUrl?: string, password?: string): string {
  if (typeof configUrl !== 'string' || !configUrl.startsWith('https')) {
    return configUrl || '';
  }

  if (!configUrl || !password) {
    return configUrl || '';
  }

  try {
    const url = new URL(configUrl);
    url.searchParams.set('password', password);
    return url.toString();
  } catch (error) {
    return configUrl || '';
  }
}

export function applyPasswordToElement(element?: HTMLElement | null, password?: string): void {
  if (!element || !password) {
    return;
  }

  const configUrl = element.getAttribute('data-config-url');
  if (!configUrl) {
    return;
  }

  element.setAttribute('data-config-url', applyPasswordToConfigUrl(configUrl, password));
}
